// Registers ECharts modules once at plugin load and exposes the
// <v-chart> component globally so every page can use it without
// importing the modules in its own setup block.
import { defineNuxtPlugin } from "#app";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  LineChart,
  BarChart,
  ScatterChart,
  PieChart,
  HeatmapChart,
  CustomChart,
} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  DataZoomComponent,
  ToolboxComponent,
  AxisPointerComponent,
  VisualMapComponent,
  GraphicComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  LineChart,
  BarChart,
  ScatterChart,
  PieChart,
  // The Tablets screen (task 1705): drops by day and hour, and the timeline's driver and motion bands.
  HeatmapChart,
  CustomChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  DataZoomComponent,
  ToolboxComponent,
  AxisPointerComponent,
  VisualMapComponent,
  GraphicComponent,
]);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("VChart", VChart);
});
